import React from 'react'
import classNames from 'classnames'
import styles from './styles.module.scss'
import { InternationalTableRowsProperties } from '..'

type SizeChartTableInternationalProps = {
  rows: InternationalTableRowsProperties[]
}

type ColumnsProps = {
  value: string | number
  index: number
}

const Columns = ({ value, index }: ColumnsProps) => {
  return (
    <th
      key={`column-${index}`}
      className={styles.sizeChart__cell}
      scope={`${index === 0 ? 'col' : 'row'}`}
    >
      {value}
    </th>
  )
}

type RowProps = {
  row: InternationalTableRowsProperties
  rowIndex: number
}
const Row = ({ row, rowIndex }: RowProps) => {
  const { name, values } = row

  const rowStyles = classNames(styles.sizeChart__row, {
    [styles.sizeChart__rowOdd]: rowIndex % 2
  })
  return (
    <tr className={rowStyles}>
      <th className={styles.sizeChart__cell}>{name}</th>
      {values.map((value, i) => (
        <Columns value={value} index={i} key={`${name}-${i}`} />
      ))}
    </tr>
  )
}

const SizeChartTableInternational = ({
  rows
}: SizeChartTableInternationalProps) => {
  return (
    <div className={styles.sizeChart__table_international}>
      <table>
        <tbody>
          {rows.map((row, index) => (
            <Row row={row} key={row.name} rowIndex={index} />
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default SizeChartTableInternational
